module.exports = __webpack_public_path__ + "img/icon-manufacture.8d2a187b.png";